import React from 'react';
import CalWeekLane from './CalWeekLane';

const CalWeekLaneRow = ({ groupData, visibleWeekMeta, sarasDnDManager, calendarControl, laneWidth, isTabletWidthOrLess, onMoveDate, weekSummaryMap }) => {
    return (
        <div className="uiCalWeekLaneRow" style={{ position: 'relative', height: '560px', background: '#fff' }}>
            {visibleWeekMeta.map((week) => (
                <CalWeekLane
                    key={week.groupKey}
                    rowKey={week.groupKey}
                    laneIndex={week.index}
                    viewData={groupData.viewRows[week.groupKey]}
                    sarasDnDManager={sarasDnDManager}
                    calendarControl={calendarControl}
                    isTabletWidthOrLess={isTabletWidthOrLess}
                    onMoveDate={onMoveDate}
                    weekSummary={weekSummaryMap?.[week.groupKey] || null}
                    laneWidth={laneWidth}
                />
            ))}
        </div>
    );
};

export default CalWeekLaneRow;
